const djrConfig = require("./brands/djr");
const risemnConfig = require("./brands/risemn");

// Determine which brand configuration to load.
// The brand is fixed at build time by REACT_APP_BRAND (default "djr").
// It is never read from the page URL.
const getBrandConfig = () => {
  const brand = process.env.REACT_APP_BRAND || "djr";

  switch (brand.toLowerCase()) {
    case "djr":
      return djrConfig;
    case "risemn":
      return risemnConfig;
    default:
      console.warn(`Unknown brand: ${brand}, defaulting to djr`);
      return djrConfig;
  }
};

// Export the selected configuration
const config = getBrandConfig();

module.exports = config;
